"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var RankingFilterButton_1 = require("./RankingFilterButton");
var RankingFilterDropdown_1 = require("./RankingFilterDropdown");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @beta
 */
exports.RankingFilter = function (_a) {
    var measureItems = _a.measureItems, attributeItems = _a.attributeItems, filter = _a.filter, onApply = _a.onApply, onCancel = _a.onCancel, buttonTitle = _a.buttonTitle, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, customGranularitySelection = _a.customGranularitySelection, locale = _a.locale, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var onButtonClick = function () {
        setIsOpen(!isOpen);
    };
    var handleApply = function (rankingFilter) {
        onApply(rankingFilter);
        setIsOpen(false);
    };
    var handleCancel = function () {
        onCancel();
        setIsOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RankingFilterButton_1.RankingFilterButton, { isActive: isOpen, onClick: onButtonClick, title: buttonTitle, className: "gd-rf-dropdown-button" }),
        isOpen ? (react_1.default.createElement(RankingFilterDropdown_1.RankingFilterDropdown, { measureItems: measureItems, attributeItems: attributeItems, filter: filter, onApply: handleApply, onCancel: handleCancel, anchorEl: ".gd-rf-dropdown-button", onDropDownItemMouseOver: onDropDownItemMouseOver, onDropDownItemMouseOut: onDropDownItemMouseOut, customGranularitySelection: customGranularitySelection, locale: locale, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric })) : null));
};
exports.RankingFilter.defaultProps = {
    onCancel: noop_1.default,
};
//# sourceMappingURL=RankingFilter.js.map